<template>
  <div>
    <input :value="text" @input="textInput()" :placeholder="placeholder" />
  </div>
</template>

<script>
export default {
  props: {
    placeholder: {
      type: String,
      required: false,
      default: ''
    }
  },
  data() {
    return {
      text: ''
    }
  },
  methods: {
    textInput() {
      this.text = event.target.value
      this.$emit('input', this.text)
    }
  }
}
</script>

<style scoped>
input {
  -webkit-appearance: textfield;
  box-sizing: content-box;
  -webkit-box-sizing: content-box;
  font-family: inherit;
  font-size: 14px;
  border: 1px solid #4271ac;

  padding: 5px 20px 5px 10px;
  width: 100px;

  -webkit-border-radius: 10em;
  -moz-border-radius: 10em;
  border-radius: 10em;

  -webkit-transition: all 0.4s;
  -moz-transition: all 0.4s;
  transition: all 0.4s;
}

.theme--dark input {
  color: white;
}

.theme--light input {
  color: black;
}

input::-webkit-search-decoration,
input::-webkit-search-cancel-button {
  display: none;
}

input:focus {
  width: 140px;
  -webkit-box-shadow: 0 0 5px rgba(109, 207, 246, 0.5);
  -moz-box-shadow: 0 0 5px rgba(109, 207, 246, 0.5);
  box-shadow: 0 0 5px rgba(109, 207, 246, 0.5);
}

@media only screen and (min-width: 600px) {
  input:focus {
    width: 250px;
    -webkit-box-shadow: 0 0 5px rgba(109, 207, 246, 0.5);
    -moz-box-shadow: 0 0 5px rgba(109, 207, 246, 0.5);
    box-shadow: 0 0 5px rgba(109, 207, 246, 0.5);
  }
}
</style>
